<p-toast key="{{ messageKey }}"></p-toast>

<app-hero *transloco="let t" [title]="t('page_status_monitor')">
  <div class="hero-buttons">
    <p-iconfield>
      <input
        pInputText
        type="text"
        maxlength="32"
        #globalFilterInput
        (input)="
          logEntryTable.filterGlobal(globalFilterInput.value, 'contains')
        "
        [placeholder]="t('search')"
        class="w-64 border-transparent hero-search-input"
      />
      <p-inputicon class="icon-search-outline" />
    </p-iconfield>
  </div>
  @if (logEntryTable?.totalRecords; as totalRecords) {
    <span class="hero-counter">{{ totalRecords }}</span>
  }
</app-hero>

<div class="px-8" *transloco="let t">
  <div class="-mt-8 bg-white shadow-md">
    <div class="p-8">
      <p-table
        *transloco="let t"
        [value]="queryEntries"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [globalFilterFields]="[
          'engagementName',
          'jobCode',
          'queriedTaxNumber',
          'statusString',
          'queriedDate',
        ]"
        sortField="queriedDate"
        [sortOrder]="-1"
        styleClass="p-datatable-sm log-table"
        dataKey="id"
      >
        <ng-template #header>
          <tr>
            <th pSortableColumn="engagementName">
              {{ t("name") }} <p-sortIcon field="engagementName"></p-sortIcon>
            </th>
            <th pSortableColumn="jobCode">
              {{ t("jobcode") }} <p-sortIcon field="jobCode"></p-sortIcon>
            </th>
            <th pSortableColumn="vatNumber">
              {{ t("vatnumber") }}
              <p-sortIcon field="vatNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="status">
              {{ t("status") }} <p-sortIcon field="status"></p-sortIcon>
            </th>
            <th pSortableColumn="created">
              {{ t("queried_date") }}
              <p-sortIcon field="created"></p-sortIcon>
            </th>
            <th>
              <!--
            </th>
            <th pSortableColumn="invoiceFilteredReportRequested">
              {{ t("status_page_inv_filter") }}
              <p-sortIcon field="invoiceFilteredReportRequested"></p-sortIcon>
            </th>
            <th pSortableColumn="datasetReportRequested">
              {{ t("status_page_report") }}
              <p-sortIcon field="datasetReportRequested"></p-sortIcon>
            </th> -->
            </th>

            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
        </ng-template>
        <ng-template #body let-logEntry>
          <tr
            attr.data-instanceid="{{ logEntry.requestId }}"
            [ngClass]="{ 'ui-disabled status-loading-row': logEntry.isLoading }"
          >
            <td>
              <span class="font-medium">{{ logEntry.engagementName }}</span>
            </td>
            <td>
              <span class="whitespace-nowrap">{{ logEntry.jobCode }}</span>
            </td>
            <td>
              <span class="-my-2 tag-vatNumber">{{ logEntry.vatNumber }}</span>
            </td>
            <td>{{ logEntry.status }}</td>
            <td>
              <render-value
                data="{{ logEntry.created }}"
                template="date"
              ></render-value>
            </td>
            <td>
              <div class="flex justify-center items-center">
                <app-status-icon
                  [requested]="logEntry.powerBiRequested"
                  [queryStatus]="logEntry.status"
                  [tooltip]="t('status_page_powerBi')"
                >
                </app-status-icon>
                <app-status-icon
                  [requested]="logEntry.invoiceFilteredReportRequested"
                  [queryStatus]="logEntry.status"
                  [tooltip]="t('status_page_inv_filter')"
                ></app-status-icon>
                <app-status-icon
                  [requested]="logEntry.datasetReportRequested"
                  [queryStatus]="logEntry.status"
                  [tooltip]="t('status_page_report')"
                ></app-status-icon>
                <app-status-icon
                  [requested]="logEntry.invoiceDetailsRequested"
                  [queryStatus]="logEntry.status"
                  [tooltip]="t('status_page_inv_details')"
                ></app-status-icon>
              </div>
            </td>
            <td
              *ngVar="
                finalStatuses.indexOf(logEntry.status) !== -1 as isFinalStatus
              "
            >
              <div [ngClass]="{ 'ui-disabled': isFinalStatus }">
                <button
                  pButton
                  pRipple
                  type="button"
                  class="p-button-text p-button-loading-icon whitespace-nowrap"
                  icon="icon-refresh-fill -ml-1 -mt-2px"
                  loadingIcon="icon-refresh-fill animate-spin -ml-1 -mt-2px"
                  [disabled]="isFinalStatus"
                  [label]="t('refresh_instance_status')"
                  (click)="refreshInstanceStatus()"
                  [loading]="logEntry.isLoading"
                ></button>
                <button
                  pButton
                  pRipple
                  type="button"
                  icon="icon-endProcess-fill relative -top-1px text-sm -ml-1 -mt-1px"
                  class="p-button-text text-grey-dark whitespace-nowrap"
                  [label]="t('terminate_instance')"
                  (click)="showTerminateConfirm(logEntry.requestId)"
                  [disabled]="isFinalStatus"
                ></button>
              </div>
            </td>
            <td>
              <a
                class="whitespace-nowrap"
                routerLink="/queryUI/download/{{ logEntry?.requestId }}"
              >
                <i class="icon-link-outline"></i>Details</a
              >
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td [attr.colspan]="10">
              <p
                class="p-12 italic font-normal text-center text-grey-medium/50"
              >
                {{ loading ? t("loading") : t("empty_message") }}
              </p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
